<div class="layout-wrapper" [class.sidebar-collapsed]="sidebarService.isCollapsed()">
  <app-sidebar class="sidebar"></app-sidebar>

  <div class="layout-main-container">
    <div class="layout-main relative">
      <app-loader></app-loader>

      <header class="header-container">
        <div class="header-left">
          <img
            src="assets/images/icons/panel-right-open.svg"
            alt="Toggle sidebar icon"
            (click)="toggleSidebar()"
            class="menu-btn hover:!bg-gray-200"
          />
        </div>

        <div class="header-right">
          <span class="admin-name">Welcome, {{ auth.admin()?.name || 'Admin' }}</span>
          <p-button size="small" label="Logout" severity="secondary" icon="pi pi-sign-out" (click)="logout()" />
        </div>
      </header>

      <router-outlet></router-outlet>
    </div>
  </div>
</div>
